import ProductPage from './pages/ProductPage';
export const pages = {
    '#productpage': ProductPage
};


// WEBPACK FOOTER //
// ./src/js/pages.js